var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { loading } from '../../../elements/Loading';
import { Label } from 'reactstrap';
import { T } from '../../../helpers/i18n';
import { Table } from '../../../components';
import theme from '../../../Theme';
import cxs from 'cxs/component';
import history from '../../../helpers/History';
var ModuleVirtual = /** @class */ (function (_super) {
    __extends(ModuleVirtual, _super);
    function ModuleVirtual() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.header = ['name', 'lastname', 'username', 'email'];
        _this.handleSelectItem = function (user) {
            history.push("/users/".concat(user.id));
        };
        return _this;
    }
    ModuleVirtual.prototype.render = function () {
        var users = this.props.users;
        console.log('users: ', users);
        if (!users || users.length === 0) {
            return (React.createElement("div", null,
                React.createElement(Label, null, T('noVirtualUsers'))));
        }
        return (React.createElement(WrapperDivTable, null,
            React.createElement("div", { style: {
                    minWidth: '75%'
                } },
                React.createElement(Label, null, T('virtualUsers')),
                React.createElement(Table, { noMinHeight: true, style: {
                        border: "1px solid ".concat(theme.color.hairline),
                    }, search: false, header: this.header, keyExtractor: function (item) { return String(item.id); }, items: users, onSelectItem: this.handleSelectItem }))));
    };
    ModuleVirtual = __decorate([
        inject('store'),
        observer,
        loading(function (props) { return [
            props.store.users.readVirtuals().then(function (users) { return ({ users: users }); })
        ]; })
    ], ModuleVirtual);
    return ModuleVirtual;
}(Component));
export { ModuleVirtual };
var WrapperDivTable = cxs('div')({
    marginTop: '20px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    width: '100%',
});



//////////////////
// WEBPACK FOOTER
// ./src/modules/Acount/container/ModuleVirtual.tsx
// module id = 1565
// module chunks = 0